
import { OrderViewModel } from "@/interfaces/OrderViewModel";
import router from "@/router";
import Vue from "vue";
import { mapGetters, mapMutations } from "vuex";
import { StyleValue } from "vue/types/jsx";
import store from "@/store";
import swal from "sweetalert";
import { AccountSettingsViewModel } from "../interfaces/AccountSettingsViewModel";

export default {
  name: "sidebar-menu",
  props: {},
  data() {
    return {
      isMobile: false,
      hideHeader: false,
      isDropFrameVisible: false,
      isMenuOpen: false,
      sidebarWidth: "250px",
      isNavOpen: true,
      sidebarOpen: false,
      accountSettings: null as AccountSettingsViewModel | null,
      isButtonSelected: {
        button1: false,
        button2: false,
        button3: false,
        button4: false,
        button5: false,
        button6: false,
      } as { [key: string]: boolean },
      activeSelected: "" as string,
      isSecondaryButtonSelected: {} as { [key: string]: boolean },
      reportsMenu: false as boolean,
      pharmacyReportsMenu: false as boolean,
      reportNames: {} as { [key: number]: string },
      showAdminMenu: false as boolean,
    };
  },
  async mounted() {
    if (this.SignedIn && (this.Role === "AffiliateAdmin" || this.Role === "Pharmacy" || this.Role === "Support" || this.Role === "Physician")) {
      await this.GetReportNames();
    }
    this.setLoading(false);
  },
  computed: {
    ...mapGetters({
      Affiliate: "getAffiliate",
      Theme: "getTheme",
      Content: "getContent",
      Loading: "getLoading",
      SignedIn: "getSignedIn",
      Role: "getRole",
      IsCollectJSLoaded: "getIsCollectJSLoaded",
      PhotoPath: "getPhotoPath",
      ShowSidebar: "getShowSidebarAdmin",
    }),
    SiteLogoStyle(): StyleValue {
      console.log(this.Theme.SiteLogoStyle);
      if (this.Theme.SiteLogoStyle) return this.Theme.SiteLogoStyle;
      else
        return {
          "max-height": "65px",
        };
    },
    dashboardRoute() {
      if (this.Role === "Admin") {
        return "/admin/dashboard";
      } else if (this.Role === "AffiliateAdmin") {
        return "/affiliateadmin/dashboard";
      } else if (this.Role === "Pharmacy") {
        return "/pharmacy/dashboard";
      } else {
        return "/";
      }
    },
  },
  methods: {
    ...mapMutations({
      setLoading: "setLoading",
      setSidebarAdmin: "setSidebarAdmin",
    }),
    async signOut() {
      await store.dispatch("SignOut");
      router.push("/signin");
    },
    async showSettings() {
      this.$emit("show-settings");
      this.setSidebarAdmin(false);
    },
    menuToggle() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    navToggle() {
      if (this.isNavOpen) {
        this.sidebarWidth = "0px";
      } else {
        this.sidebarWidth = "250px";
      }
      this.isNavOpen = !this.isNavOpen;
    },

    toggleSidebar() {
      this.sidebarOpen = !this.sidebarOpen;
    },
    showSelected(button: string, routePath: string) {
      for (const key in this.isButtonSelected) {
        this.isButtonSelected[key] = false;
      }

      this.isButtonSelected[button] = true;
      this.activeSelected = button;
      this.reportsMenu = false;
      this.$router.push(routePath);
      this.setSidebarAdmin(false);
      this.isSecondaryButtonSelected.button1 = false;

      Object.keys(this.reportNames).forEach((key) => {
        this.$set(this.isSecondaryButtonSelected, key, false);
      });
    },
    showReportsSecondaryMenu(button: string, routePath: string) {
      for (const key in this.isButtonSelected) {
        this.isButtonSelected[key] = false;
      }

      this.isButtonSelected[button] = true;
      this.activeSelected = button;

      this.reportsMenu = true;
      const targetWord = ["details"];

      if (targetWord.every((word) => this.$route.path.includes(word))) {
        return;
      }

      this.$router.push(routePath);
    },
    closeReportsMenu() {
      this.reportsMenu = false;
    },

    showSecondarySelected(reportKey: string, reportValue: string) {
      // Reset all selections to false
      Object.keys(this.reportNames).forEach((key) => {
        this.$set(this.isSecondaryButtonSelected, key, false);
      });

      // Set the selected report as active
      this.$set(this.isSecondaryButtonSelected, reportKey, true);

      const roleRoute = {
        AffiliateAdmin: "affiliateadminreportparameter",
        Pharmacy: "pharmacyreportparameter",
        Support: "supportreportparameter",
        Physician: "physicianreportparameter",
      };

      const routeName = roleRoute[this.Role];

      // Navigate to the new route
      this.$router.push({
        name: routeName,
        params: { reportId: reportKey, reportName: reportValue },
      });
      this.setSidebarAdmin(false);
    },

    async GetReportNames() {
      try {
        const roleEndpointMap = {
          AffiliateAdmin: "/api/affiliateadmin/GetReportNames",
          Pharmacy: "/api/pharmacy/GetReportNames",
          Support: "/api/support/GetReportNames",
          Physician: "/api/physician/GetReportNames",
        };

        const endpoint = roleEndpointMap[this.Role];

        const reportNames = await this.$store.dispatch("GetReportNames", endpoint);
        this.reportNames = reportNames;
      } catch (error) {
        console.error("Error fetching report names:", error);
      }
    },

    closeSidebarMenu() {
      this.setSidebarAdmin(false);
    },
  },
};
